(function () {
  const root = document.querySelector('.zk-cartrem[data-section-id]');
  if (!root) return;

  const enabled = root.dataset.enabled === 'true';
  if (!enabled) return;
  if (window.location.pathname.includes('/checkout')) return;

  const sid = root.dataset.sectionId;
  const isAr = root.dataset.isAr === 'true';
  const showOnce = root.dataset.showOnce === 'true';

  const exitTop = parseInt(root.dataset.exitTop || '50', 10);
  const mobileTimeEnabled = root.dataset.mobileTimeEnabled === 'true';
  const mobileDelaySec = parseInt(root.dataset.mobileDelay || '10', 10);

  const desktopScale = parseFloat(root.dataset.desktopScale || '1.1');
  const mobileScale = parseFloat(root.dataset.mobileScale || '1.0');

  const KEY = `zkcr_shown_${sid}`;

  const closeEls = root.querySelectorAll('[data-zkcr-close]');
  const itemsLine = root.querySelector('[data-zkcr-itemsline]');
  const i18nEl = root.querySelector('script[data-zkcr-i18n]');

  let i18n = {
    before_en: "You've got",
    after_en: "items in the cart",
    before_ar: "عندك",
    after_ar: "منتجات في السلة"
  };

  try {
    if (i18nEl) i18n = Object.assign(i18n, JSON.parse(i18nEl.textContent || '{}'));
  } catch (_) {}

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function applyScale() {
    const modal = root.querySelector('.zk-cartrem__modal');
    if (!modal) return;
    const s = isMobile() ? mobileScale : desktopScale;
    modal.style.transform = `scale(${s})`;
  }

  function markShown() {
    if (!showOnce) return;
    try { sessionStorage.setItem(KEY, '1'); } catch (_) {}
  }

  function alreadyShown() {
    if (!showOnce) return false;
    try { return sessionStorage.getItem(KEY) === '1'; } catch (_) { return false; }
  }

  async function getCartCount() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    const data = await res.json();
    return Number(data.item_count || 0);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    }[m]));
  }

  function renderLine(count) {
    const before = isAr ? i18n.before_ar : i18n.before_en;
    const after = isAr ? i18n.after_ar : i18n.after_en;

    itemsLine.innerHTML = `
      <span class="zkcr-muted">${escapeHtml(before)} </span>
      <span class="zkcr-count">${count}</span>
      <span class="zkcr-muted"> ${escapeHtml(after)}</span>
    `;
  }

  function openPopup(count) {
    if (alreadyShown()) return;
    applyScale();
    renderLine(count);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    markShown();
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
  }

  closeEls.forEach((el) => el.addEventListener('click', closePopup));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closePopup();
  });

  // Desktop exit intent
  let exitArmed = true;
  function onMouseMove(e) {
    if (!exitArmed) return;
    if (isMobile()) return;
    if (e.clientY <= exitTop) {
      exitArmed = false;
      getCartCount().then((count) => {
        if (count > 0) openPopup(count);
      }).catch(() => {});
      document.removeEventListener('mousemove', onMouseMove);
    }
  }
  document.addEventListener('mousemove', onMouseMove, { passive: true });

  function scheduleMobilePopup() {
    if (!mobileTimeEnabled) return;
    window.setTimeout(() => {
      if (!isMobile()) return;
      getCartCount().then((count) => {
        if (count > 0) openPopup(count);
      }).catch(() => {});
    }, Math.max(0, mobileDelaySec) * 1000);
  }

  // Form submit add-to-cart
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart/add')) scheduleMobilePopup();
  }, true);

  // AJAX add-to-cart fetch
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    try {
      const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      const u = String(url).toLowerCase();
      if (u.includes('/cart/add')) {
        return origFetch.apply(this, args).then((res) => {
          scheduleMobilePopup();
          return res;
        });
      }
    } catch (_) {}
    return origFetch.apply(this, args);
  };

  window.addEventListener('resize', applyScale, { passive: true });
})();
